export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/pet_portrait.c1503d0.svg";